module.exports = __webpack_public_path__ + "static/urlissue-802cdbcce70ae038a2c879a527072aaa.png";